<template>
  <div class="app-container">
    <CrudTable
      entity="StoreFabric"
      :allow-create="false"
      :allow-edit="false"
      :allow-delete="false"
      :columns="columns"
      :generate-summary="generateSummary"
      :show-action-icons-in-list="false"
      :on-row-dbl-click="() => {}"
    />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
import { ProductTypeOption } from '@/utils/constants';
import { FabricStatusOption } from '@/utils/constants';

const Labels = {
  Blackout: 'fabric.blackout',
  Pattern: 'fabric.pattern',
  Solid: 'fabric.solid',
  Yes: 'common.yes',
  No: 'common.no'
};

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        { field: 'code', label: 'fabric.domainProductCode' },
        { field: 'description', label: 'fabric.description' },
        {
          field: 'productTypeDescription',
          label: 'common.fabricType',
          filter: {
            type: 'select',
            options: this.fabricProductTypes,
            valueField: 'description',
            labelField: 'description'
          },
          sortable: false
        },
        {
          field: 'fabricStatusOption',
          label: 'fabric.fabricStatusOption',
          formatter: this.formatFabricStatus,
          filter: {
            type: 'select',
            options: this.$store.getters['option/loadedOptions']('fabricStatus').filter(
              s => s.code === FabricStatusOption.Active || s.code === FabricStatusOption.LastStock
            ),
            valueField: 'code',
            labelField: 'description'
          },
          sortable: false
        },
        {
          field: 'hasPatternYN',
          label: 'fabric.pattern',
          formatter: this.formatStaggeredPattern,
          filter: {
            type: 'select',
            options: [
              { value: true, label: this.$t(Labels.Pattern) },
              { value: false, label: this.$t(Labels.Solid) }
            ],
            valueField: 'value',
            labelField: 'label'
          },
          sortable: false
        },
        {
          field: 'blackoutYN',
          label: 'fabric.blackout',
          formatter: this.formatBlackout,
          filter: {
            type: 'select',
            options: [
              { value: true, label: this.$t(Labels.Yes) },
              { value: false, label: this.$t(Labels.No) }
            ],
            valueField: 'value',
            labelField: 'label'
          },
          sortable: false
        },
        {
          field: 'availableStockInMeters',
          label: 'storeFabric.availableStockInM',
          filter: { type: 'none' }
        },
        {
          field: 'soldStockInMeters',
          label: 'storeFabric.soldStockInM',
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'estimatedDeliveryDate',
          label: 'storeFabric.estimatedNewStock',
          type: 'date',
          filter: { type: 'none' },
          sortable: false
        }
      ]
    };
  },
  computed: {
    fabricProductTypes() {
      return this.$store.getters['productType/loadedItems'];
    }
  },
  watch: {
    fabricProductTypes(fabricProductTypes) {
      this.getColumn('productTypeDescription').filter.options = fabricProductTypes;
    }
  },
  created() {
    const params = {
      query: {
        productTypeOption: ProductTypeOption.Fabric
      }
    };
    this.$store.dispatch('productType/getItems', params);
  },
  methods: {
    getColumn(fieldName) {
      return this.columns.find(c => c.field === fieldName);
    },
    generateSummary({ description }) {
      return `${description}`;
    },
    formatFabricStatus(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('fabricStatus').find(item => item.code === cellValue);
      return option && option.description;
    },
    formatStaggeredPattern(row, column, cellValue) {
      if (cellValue !== null) {
        return cellValue ? this.$t(Labels.Pattern) : this.$t(Labels.Solid);
      }
      return '';
    },
    formatBlackout(row, column, cellValue) {
      if (cellValue !== null && cellValue) {
        return this.$t(Labels.Blackout);
      }
      return '';
    }
  }
};
</script>
